import { get } from '.';

export function GetAiCommunicationCarlieDetails(id, options = {}, signal?: AbortSignal) {
	return get<any>("/app/api/ai_communications/" + (id || 0).toString() + "/carlie_details", options, {}, signal);
}
